/* eslint-disable @typescript-eslint/no-unused-vars */
export const audienceBudgetBidsStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '& .crud-audience-budget-bid': {

    padding: '0 32px 15px 32px',

    '& .control-label:nth-child(1)': {
      marginTop: 24,
    },

    '& .budget': {
      '& .form-control-static': {
        minHeight: 1,

        '& .col-sm-fluid': {
          float: 'left',
          paddingRight: 10,
        },
      },
    },

    '& .bid__container > .form-group': {
      '& .form-control-static': {
        minHeight: 1,
      },
    },

    '& .default-bid': {
      float: 'none',

      '& .input-group': {
        paddingTop: 5,
      },


      '& .input-group-addon': {
        backgroundColor: palette.white,
        border: 0,
      },


      '& .kpiestimation-result': {
        '& .panel-heading': {
          marginBottom: 15,
          border: 0,
        },
      },
    },

    '& .bid-adjustments-container, .adschedule-targets-container': {
      border: 0,

      '& .bid-adjustment-targets-container, .adschedule-targets': {
        padding: [0, 15],
      },

      '& .bid-adjustments-section, .adschedule-section': {
        zIndex: 1,

        '&:focus, &:hover': {
          outline: 'none',
          border: 'none',
          textDecoration: 'none',
          color: palette.themePrimary,
          background: palette.neutralLighter,
        },
      },
    },

    '& .container-budget': {
      paddingLeft: '0 !important',
    },

  },
  '& .criterion-setting-container': {
    '&.show-cashback-percent': {
      '& .bid-adjustment-grids-container .table-container, & .location-bid-grid-container .table-container': {
        width: 856,
        '& .inherit-cashback-value': {
          display: 'inline-block',
        },
        '& .cashback-option-select.form-control': {
          width: '180px !important',
        },
        '& .input-group-addon': {
          padding: 0,
          lineHeight: '30px',
          verticalAlign: 'middle',
          background: 'none',
        },
      },
    },
    '&.criterion-setting-CompanyName.show-cashback-percent': {
      '& .bid-adjustment-grids-container .table-container': {
        width: 1100,
      },
    },
    '&.criterion-setting-Industry.show-cashback-percent': {
      '& .bid-adjustment-grids-container .table-container': {
        width: 1000,
      },
    },
    '&.criterion-setting-JobFunction.show-cashback-percent': {
      '& .bid-adjustment-grids-container .table-container': {
        width: 900,
      },
    },
    '&.criterion-setting-Audience.show-cashback-percent': {
      '& .bid-adjustment-grids-container .table-container': {
        width: 1050,
        '& .column-name-Target': {
          width: 300,
        },
      },
    },
    '& .target-edit-container, .bid-adjustment-grids-container': {

      '& table.table--no-border>tbody>tr:hover': {
        background: palette.neutralLight,
        '& td': {
          border: `1px solid ${palette.white}`,
        },
      },

      '& .table-container': {
        width: 716,

        '& .header': {
          padding: '11px 7px 12px 7px',

          '& tr > th': {
            fontWeight: 'normal',
            height: '42px',
            wordBreak: 'break-all',
          },

          '& tr > th:first-child': {
            width: 140,
          },

          '& tr > th:nth-child(3)': {
            width: 249,
          },
        },

        '& tbody': {
          '& tr > td': {
            fontWeight: 'normal',
            height: '42px',
            wordBreak: 'break-all',
          },

          '& tr > .text-left:first-child': {
            '& .statusEnabled_icon, .statusExcluded_icon': {
              lineHeight: '19px',
              padding: '12px 9px 11px 7px',
            },
          },

          '& tr > .text-left:nth-child(2)': {
            padding: '0px 7px',
            lineHeight: '20px',
            '&.col-location': {
              wordBreak: 'break-word',
            },
          },

          '& tr > .text-left:nth-child(3), & tr > .text-left:nth-child(4)': {
            padding: '0px 7px',

            '& .form-inline': {
              '& .form-control': {
                marginRight: 8,
                width: 135,
                padding: '0 28px 0 8px',
              },

              '& .inline-input, & input[type=text]': {
                width: 66,
                padding: '0 8px',
              },

              '& .error': {
                margin: 0,
              },
            },
          },

          '& .company-item-template': {
            paddingTop: 2,

            '& .pull-left': {
              marginTop: 5,
              marginRight: 7,

              '& img': {
                width: 32,
                height: 32,
                overflow: 'hidden',
                display: 'block',
              },
            },

            '& .company-name': {
              width: 310,
              lineHeight: '20px',

              '& .company-item-name, .company-item-industry': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                paddingRight: 5,
              },
            },
          },
        },

        '& .footer': {
          '& .pagination-control': {
            '& .pager': {
              display: 'inline-block',
              marginLeft: 20,
            },
          },
        },
      },
    },
  },
});
